import { makeStyles } from '@material-ui/core/styles';

import { fontWeight } from 'theme/typography';

export const useTileStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.gray.darker,
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(5.5, 6),
    height: '100%',
  },
  icon: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
  number: {
    fontSize: theme.spacing(6),
    fontFamily: theme.typography.secondaryFontFamily,
    fontWeight: fontWeight.semiBold,
    marginTop: theme.spacing(2.5),
  },
  subtitle: {
    fontSize: theme.typography.h3.fontSize,
    color: ({ color }: { color: string }) => color,
    fontFamily: theme.typography.secondaryFontFamily,
    fontWeight: fontWeight.bold,
    marginBottom: theme.spacing(4),
    textAlign: 'center',
  },
  button: {
    color: 'white',
    borderColor: 'white',
    borderRadius: 0,
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    marginTop: 'auto',
    '&:hover': {
      color: 'white',
      borderColor: 'white',
    },
  },
}));
